import { Component, ErrorInfo, ReactNode } from 'react';

type State = { err?: Error };

/** Last-resort boundary so a render error shows a message instead of a blank page. */
export default class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = {};

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  componentDidCatch(err: Error, info: ErrorInfo) {
    console.error('Uncaught error:', err, info);
  }

  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink p-8 text-center text-fg-muted">
          <div>
            <div className="mb-2 text-[15px] text-fg-strong">Something went wrong</div>
            <div className="text-[13px]">{this.state.err.message}</div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
